var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"fullview"},[_c('div',{staticClass:"loading-spacer"}),_c('vue-loading',{attrs:{"type":"spin","color":"#b2cbe4","size":{ width: '200px', height: '200px' }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }